import React, { useState } from "react";
import { useTheme } from "../../providers/ThemeContext";
import { useI18n } from "../../languages/providers/I18nProvider";

const AnnouncementBar = () => {
  const { theme } = useTheme();
  const { t, lang } = useI18n();
  const [visible, setVisible] = useState(true);

  const isArabic = lang === "ar";
  const message = t("announcement:orderReady");

  if (!visible) return null;

  const repeated = Array(6).fill(null);

  return (
    <div
      className="announcementBar"
      dir={isArabic ? "rtl" : "ltr"}
      style={{
        background: theme.color3,
        color: theme.text3,
      }}
    >
      <div className="marqueeTrack">
        {repeated.map((_, i) => (
          <span key={i} className="marqueeItem">
            <span className="announcementIcon">◷</span>
            <span className="announcementText">{message}</span>
   
          </span>
        ))}
      </div>

      <div
        className="fadeEdge"
        style={{
          background: `linear-gradient(to right, transparent, ${theme.color3})`,
        }}
      />

      <button
        className="announcementClose"
        onClick={() => setVisible(false)}
        aria-label="Dismiss announcement"
        style={{ color: theme.text3 }}
      >
        ✕
      </button>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap');

        .announcementBar {
          width: 100%;
          height: 36px;
          overflow: hidden;
          display: flex;
          align-items: center;
          position: relative;
          font-size: 13px;
          font-weight: 500;
          font-family: 'Poppins', sans-serif;
          letter-spacing: 0.02em;
          z-index: 100;
        }

        .marqueeTrack {
          display: flex;
          white-space: nowrap;
          animation: marqueeScroll 20s linear infinite;
          will-change: transform;
        }

        [dir="rtl"] .marqueeTrack {
          animation-name: marqueeScrollRTL;
        }

        @keyframes marqueeScroll {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        @keyframes marqueeScrollRTL {
          0%   { transform: translateX(0); }
          100% { transform: translateX(50%); }
        }

        .marqueeItem {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding-right: 110px;
        }

        .announcementIcon {
          font-size: 14px;
          opacity: 0.8;
        }

        .announcementText {
          white-space: nowrap;
        }

        .fadeEdge {
          position: absolute;
          right: 36px;
          top: 0;
          height: 100%;
          width: 64px;
          pointer-events: none;
          z-index: 1;
        }

        [dir="rtl"] .fadeEdge {
          right: auto;
          left: 36px;
          transform: scaleX(-1);
        }

        .announcementClose {
          position: absolute;
          right: 14px;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          cursor: pointer;
          font-size: 13px;
          opacity: 0.6;
          padding: 4px 6px;
          line-height: 1;
          transition: opacity 0.2s ease;
          font-family: 'Poppins', sans-serif;
          z-index: 2;
        }

        .announcementClose:hover {
          opacity: 1;
        }

        [dir="rtl"] .announcementClose {
          right: auto;
          left: 14px;
        }

        @media (max-width: 640px) {
          .announcementBar {
            height: 34px;
            font-size: 12px;
          }
          .marqueeTrack {
            animation-duration: 14s;
          }
        }
      `}</style>
    </div>
  );
};

export default AnnouncementBar;